module.exports = __webpack_public_path__ + "img/flottfard1.ecb9b381.jpg";